import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { toast } from 'react-toastify';
import '../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import RefundSummary from "./components/RefundSummary.js";

function Details() {
  const { refundID } =  useParams();  
  const navigate   = useNavigate();
  const { t }     = useTranslation();
  const BASE  = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(false);
  const [pageContent, setPageContent] = useState({});

  useEffect(() => {
    loadOrderDetails();
  }, []);
   
  const loadOrderDetails = () => {
    setIsLoading(true);
    axios({      
          url     : BASE+"api/refund/view/"+refundID,
          method  : "GET",
          headers : {
            Authorization   : `Bearer ${TOKEN}`,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            const responseData           = response.data;
            const responseDataStatusCode = responseData.status;
            const responseMessage        = responseData.message;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);
                if(responseDataStatusCode === 0)
                {
                    if(responseMessage)
                    toast.error(t(responseMessage));
                    else
                    toast.error(t('An unexpected error occurred while communicating with server'));

                    const redirectTimeout = setTimeout(() => {          
                      clearTimeout(redirectTimeout);          
                      navigate("/refunds/list");          
                    }, 3000);
                }
                else if(responseDataStatusCode === 1 && responseData && responseData.data)
                {
                    setPageContent(responseData.data);
                }
            }  
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }        
        }).catch(function (error) {
          setIsLoading(false);
          handleErrors(error, t, navigate);
        });
  }
    
  return (
      <DashboardLayout>        
        {Object.keys(pageContent).length > 0 ? 
        <>
          <DashboardNavbar pageTitle={t('Refund Details')} />
          <MDBox my={3}>

            <Grid container spacing={2} my={1}>
                {isLoading ?  
                  <Grid item xs={12}>
                    <Box className='circularLoadingCommonOuter'>
                        <CircularProgress size={30} className='circularLoadingCommon' />
                    </Box>
                  </Grid>
                : <></>}

                <Grid item xs={12}>
                  <Card mb={2} variant="outlined">
                    <CardContent>
                      <Grid container spacing={0} mt={1}>
                        <Grid item sm={6} xs={12} my={2}>
                          <Typography variant="h6" color="text.secondary">
                            {t('Order refund details')}
                          </Typography>
                        </Grid>                    
                      </Grid>

                      <RefundSummary 
                        refundID    = {refundID} 
                        pageContent = {pageContent} 
                      />  

                    </CardContent>
                  </Card>
                </Grid>
            </Grid>
          </MDBox>
        </>         
      : <></>}        
      </DashboardLayout>
  );
}
export default Details;
